import { useEffect, useState } from "react";
import { XALTIX_CSS, Emblem } from "./XaltixWelcome";

const CSS = `
@keyframes osOut{to{opacity:0;visibility:hidden}}
.os-out{animation:osOut .45s ease 1.75s forwards}
.os-emb{position:relative;overflow:hidden;border-radius:9999px}
.os-emb::before{content:"";position:absolute;inset:-20%;z-index:2;pointer-events:none;background:linear-gradient(115deg,transparent 38%,rgba(255,240,190,.75) 50%,transparent 62%);transform:translateX(-120%);animation:osSweep 1.25s cubic-bezier(.4,0,.2,1) .35s forwards;mix-blend-mode:screen;-webkit-mask:url(/xaltix-emblem.png) center/contain no-repeat;mask:url(/xaltix-emblem.png) center/contain no-repeat}
@keyframes osSweep{to{transform:translateX(120%)}}
@keyframes osUp{from{opacity:0;transform:translateY(8px);letter-spacing:.6em}to{opacity:1;transform:none}}
.os-up{animation:osUp .8s cubic-bezier(.2,.7,.2,1) both}
@media (prefers-reduced-motion:reduce){.os-emb::before,.os-up{animation:none}}
`;

const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;

// Écran d'ouverture de l'application installée : reflet doré sur l'emblème, puis XALTIX (et « Espace agent »).
export const OpeningSplash = () => {
  const forced = new URLSearchParams(window.location.search).has("splash");
  const [show, setShow] = useState(() => forced || (standalone() && !sessionStorage.getItem("xaltix_splash")));
  const agent = window.location.pathname.startsWith("/agent");
  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem("xaltix_splash", "1");
    const t = setTimeout(() => setShow(false), 2250);
    return () => clearTimeout(t);
  }, [show]);
  if (!show) return null;
  return (
    <div data-testid="opening-splash" className="xl os-out fixed inset-0 z-[300] grid place-items-center"
      style={{ background: "radial-gradient(700px circle at 50% 42%, #1A4BC0 0%, #0B2A7A 50%, #06184A 100%)" }}>
      <style>{"@import url('https://fonts.googleapis.com/css2?family=Michroma&family=Manrope:wght@400;700&display=swap');" + XALTIX_CSS + CSS}</style>
      <div className="flex flex-col items-center text-center">
        <div className="xl-zoom os-emb w-32 h-32 sm:w-40 sm:h-40"><Emblem className="w-full h-full" /></div>
        <div className="os-up xl-h xl-gold text-xl sm:text-2xl mt-7" style={{ animationDelay: ".55s" }} data-testid="opening-splash-name">XALTIX</div>
        {agent && <div className="os-up xl-h text-[10px] sm:text-xs text-[#F6D88A]/80 mt-2" style={{ animationDelay: ".8s" }} data-testid="opening-splash-agent">ESPACE AGENT</div>}
      </div>
    </div>
  );
};
